import { useState, useEffect } from 'react'
import {Auth} from 'aws-amplify'
import moment from 'moment'
import axios from 'axios'
import ReferenceList from './ReferenceList'
import ReferenceUpdate from './ReferenceUpdate'

const ReferenceData = () => {
    const currentDate = moment()
    const [referenceData, setReferenceData] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getReferenceData()
    }, [])

    const getReferenceData = async () => {
        setErrorMsg('')
        setLoading(true)
        setReferenceData([])
        let session = await Auth.currentSession()
        let jwt = session.getIdToken().getJwtToken()

        axios
        .get(`${process.env.REACT_APP_API_URL}/referencelist?currentDate=${currentDate.format('YYYY-MM-DD')}`, 
        {headers: {Authorization: jwt}}
        )
        .then(response => {
            setReferenceData(response.data.rows)
            setLoading(false)
            })
        .catch(error => {
            console.log('The error is: ', error)
            setErrorMsg('Problem retrieving data: ', error)
            setLoading(false)
        })            
    }

    return (
        <div className="report">
            <h3>Reference Data - {currentDate.format('MM/DD/YYYY')}</h3>
            { loading && <h3>Loading...</h3>}
            {errorMsg && <p className="form__error">{errorMsg}</p>}
            <ReferenceList referenceData={referenceData} />
            <ReferenceUpdate referenceData={referenceData}/>
        </div>
    )
}

export default ReferenceData